import { render, staticRenderFns } from "./BookingGeneralDataTable.vue?vue&type=template&id=2e5d7f5f&scoped=true&"
import script from "./BookingGeneralDataTable.vue?vue&type=script&lang=js&"
export * from "./BookingGeneralDataTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e5d7f5f",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VCheckbox } from 'vuetify/lib/components/VCheckbox';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VCardTitle,VCheckbox,VChip,VCol,VDataTable,VIcon,VRow,VTextField,VTooltip})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2e5d7f5f')) {
      api.createRecord('2e5d7f5f', component.options)
    } else {
      api.reload('2e5d7f5f', component.options)
    }
    module.hot.accept("./BookingGeneralDataTable.vue?vue&type=template&id=2e5d7f5f&scoped=true&", function () {
      api.rerender('2e5d7f5f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Booking/BookingGeneralDataTable.vue"
export default component.exports